import type { TApprovalStatus } from "@modules/docs";

export const renderDocumentStatus = (fileStatus: TApprovalStatus): string => {
  switch (fileStatus) {
    case "pending":
      return "text-accent-yellow-700 bg-accent-yellow-50";
    case "in_review":
      return "text-accent-blue-700 bg-accent-blue-50";
    case "approved":
      return "text-accent-green-700 bg-accent-green-100";
    case "rejected":
      return "text-accent-red-600 bg-accent-red-50";
    default:
      return "text-neutral-500 bg-neutral-200";
  }
};

export const renderDocumentStatusText = (
  fileStatus: TApprovalStatus,
): string => {
  switch (fileStatus) {
    case "pending":
      return "Pending";
    case "in_review":
      return "In Review";
    case "approved":
      return "Approved";
    case "rejected":
      return "Rejected";
    default:
      return "Draft";
  }
};
